module.exports = __webpack_public_path__ + "static/img/200332.c84cb0d2.png";